module.exports = __webpack_public_path__ + "assets/img/game-num.0b7c2a84.png";